module.exports = __webpack_public_path__ + "img/symbol_6.7de9abf2.png";